import React, {useState, useEffect} from 'react'
import logo from '../images/giaa.png';
import title from '../images/certificate-title.jpg';
import separator from '../images/separator.png';
import badge from '../images/badge.jpg';
import { $ } from 'react-jquery-plugin';

// import '../../src/css/developer3.css';

import '../../src/css/certificate.css';
import axios from "axios";
import { certify, rules } from '../apis/urls';
import moment from 'moment';
import { savePDF, PDFExport } from '@progress/kendo-react-pdf';
import { Navigate, useNavigate, Link, useParams } from "react-router-dom";




const Certificate = (props) => {

    const certiRef = React.createRef();
    const [fname, setFname] = useState('');
    const [lname, setLname] = useState('');
    const [association, setAssociation] = useState('');
    const [date, setDate] = useState('');
    const [number, setNumber] = useState('');

    const [result, setResult] = useState([]);
    const [rulesdetails, setRulesDetails] = useState([]);

    const { rid } = useParams();

useEffect(() => {
    console.log("certificate from use effect");
    certific();
    RuleListing();
    $('body').removeClass('').addClass('sidebar-collapsed');
   
},[]);

let currentYear = new Date().getFullYear();


let datess = moment(result.test_date).format("DDMMYYYY");


const RuleListing = () => {

        

    let token = "Bearer "+localStorage.getItem('token');

    
    
    const instance = axios.create({

        baseURL: rules+"/"+rid,

        timeout: 1000000,

        headers: {'authorization': token}

      });
      
      instance.get('').then((response) =>{
        
        setRulesDetails(response.data.data);  
        console.log('resultssssss',response.data.data)
                 
      }).catch((error) =>{
        
        console.log('error',error.message)
        

      });
}



const certific = () => {

    

    let token = "Bearer "+localStorage.getItem('token');
    let coachId = localStorage.getItem('coachid');
    console.log("coach id is",coachId);

        const data = {
            coach_id:coachId,
            rule_id:rid,
        }
         
        console.log("data is",data);       
        const instance = axios.create({
            baseURL: certify,
            timeout: 1000000,
            
            headers: {'authorization': token,
                     'content-type':"application/json"
        }
        });
        

        instance.post('', data).then(response => {
           
            setResult(response.data.data[0]);


            let element = document.querySelector('.certificate_grid') || document.body;

            savePDF(element, {
                paperSize: 'auto',
                landscape:'true',
                fileName: 'Certificate.pdf',
                margin: 10,
                padding: 20,
                fontSize:'30px'
              });
        
        }).catch(error => {
            
            console.log('error',error)
        });

}

  return (


    <div className="wrapper">
        
    <aside className="right-side ">

        <div className="content-area">


    <div className='certificate_grid' style={{marginLeft:"4.5%"}}>

    {/* <div ref={certiRef}>
        Vishnu
    </div> */}
        <div className="certificate-wrpr" style={{margin:"0 auto"}}>
            <div className="certificate-border">
                <div className="transparent-border">
                    <div className="innerbox">
                        <div className="logo-and-certificate-title-wrpr">
                            <div className="logo-wrpr">
                                {/* <img src="./Certificate_files/logo.jpg" width="" height=""> */}
                                <img src={logo} className="logo" alt="Logo" />
                            </div>
                            <div className="title-wrpr">
                                {/* <img src="./Certificate_files/certificate-title.jpg" width="" height=""> */}
                                <img src={title} className="certify-title" alt="Title" />

                                <div className="sub-title">
                                    of Achievement
                                </div>
                                {/* <img src="./Certificate_files/separator.png" width="" height="" alt=""> */}
                                <img src={separator} className="certify-seperator" alt="seperate" />
                                    
                            </div>
                                <div className="">
                                        &nbsp;
                                    </div>
                            </div>
                            <div className="certify-that">
                                This Certifies that 
                            </div>

                            
                        
                            <div className="dottedline">
                                &nbsp;
                                <span>{result.firstName} {result.last_name}</span>
                            </div>
                            <div className="dottedline">
                                &nbsp;
                                <span>{result.school}</span>
                            </div>
                            <div className="dottedline">
                                <span>Has Successfully Completed {rulesdetails.rule_name}</span>
                            </div>
                        
                            <div className="badge-and-date">
                                <div className="fillwith">
                                    Certificate
                                    <span>{result.certificate_number}</span>
                                </div>
                                <div className="badge">
                                    {/* <Image ="./Certificate_files/badge.jpg" width="" height="" alt=""> */}
                                    <img src={badge} classNameName="certify-seperator" alt="badge" />
                                </div>
                                <div className="completedon">
                                    Completed On
                                    {/* <span>{moment(result.test_date).format('LL')}</span> */}
                                    <span>{result.test_date}</span>
                                </div>
                            </div>
                
                        </div>
                    </div>
                </div>

            </div>

        </div>

        </div>
    </aside>
</div>

  )

}

export default Certificate